import { publicClient, privateClient } from './client';
import { GuestValidateEmail } from './GuestValidateEmail';

const customGuestValidateEmail = (pub: boolean) => new GuestValidateEmail(pub ? publicClient : privateClient);
export default customGuestValidateEmail;
